import type { ReactNode } from 'react';

import FaqAccordion from '../Widgets/FaqAccordion';
import ContactAnswer from './TenantContentContainer/ContactAnswer';
import ParticipantContainer from './ParticipantContainer';

type OwnProps = {
  children?: ReactNode;
  breadcrumbLink?: string;
  breadcrumbText?: string;
  isLeaseRenewal?: boolean;
};

export function TenantContentContainer({ children, breadcrumbLink, breadcrumbText, isLeaseRenewal }: OwnProps) {
  function renderFaq(): ReactNode {
    const sections = isLeaseRenewal
      ? [
          {
            label: 'Why do I need to log in to view my lease renewal agreement?',
            description:
              'In part to help protect the sensitive information in the document. ' +
              'This also ensures that you and your landlord are viewing the most ' +
              'recent version of the lease renewal agreement in Zillow’s system.',
          },
          {
            label: 'What if I’d like changes made to the lease renewal agreement?',
            description:
              'You’ll be able to ask for changes when you view the lease renewal agreement. ' +
              'If your landlord agrees, they will cancel this signing, make the ' +
              'changes, then request your signature on the revised lease renewal agreement.',
          },
          {
            label: 'Who else can see my lease renewal agreement online?',
            description: 'Your landlords and any co-tenants also have access to the same document.',
          },
          {
            label: 'Will I be able to sign my lease renewal agreement online?',
            description:
              'Yes. Once you sign in or create an account, you will be able to review the ' +
              'lease renewal agreement, adopt an electronic signature, and sign your lease renewal agreement online.',
          },
          {
            label: 'How do I download or print this lease renewal agreement?',
            description:
              'When reviewing the lease renewal agreement, you can download an un-signable draft directly ' +
              'from your web browser. Once everyone signs your lease renewal agreement, you can download a ' +
              'signed copy anytime.',
          },
          {
            label: 'Still have questions? Contact us',
            description: <ContactAnswer />,
          },
        ]
      : [
          {
            label: 'Why do I need to log in to view my lease?',
            description:
              'In part to help protect the sensitive information in the document. ' +
              'This also ensures that you and your landlord are viewing the most ' +
              'recent version of the lease in Zillow’s system.',
          },
          {
            label: 'What if I’d like changes made to the lease?',
            description:
              'You’ll be able to ask for changes when you view the lease. ' +
              'If your landlord agrees, they will cancel this signing, make the ' +
              'changes, then request your signature on the revised lease.',
          },
          {
            label: 'Who else can see my lease online?',
            description: 'Your landlords and any co-tenants also have access to the same document.',
          },
          {
            label: 'Will I be able to sign my lease online?',
            description:
              'Yes. Once you sign in or create an account, you will be able to review the ' +
              'lease, adopt an electronic signature, and sign your lease online.',
          },
          {
            label: 'How do I download or print this lease?',
            description:
              'When reviewing the lease, you can download an un-signable draft directly ' +
              'from your web browser. Once everyone signs your lease, you can download a ' +
              'signed copy anytime.',
          },
          {
            label: 'Still have questions? Contact us',
            description: <ContactAnswer />,
          },
        ];

    return <FaqAccordion sections={sections} title="You may be wondering…" />;
  }

  return (
    <ParticipantContainer
      breadcrumbText={breadcrumbText}
      breadcrumbLink={breadcrumbLink}
      rightSidebarContent={renderFaq()}
    >
      {children}
    </ParticipantContainer>
  );
}

export default TenantContentContainer;
